import React from 'react';
import { Container, Typography } from 'pencil';
import makeStyles from 'pencil/styles/makeStyles';
import { useTheme } from 'pencil/styles';
import Divider from 'pencil/Divider';
import Box from 'pencil/Box';

import LanguageSwitcher from './LanguageSwitcher';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      paddingTop: theme.spacing(1),
    },
    divider: {
      marginBottom: theme.spacing(1),
    },
  }),
  { name: 'MlcGoFooter' },
);

function Footer({ children }) {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <footer className={classes.root}>
      <div>
        <Container maxWidth={theme.layout.width}>
          <Divider className={classes.divider} />
          <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap">
            <Typography color="textSecondary" variant="caption">
              {children}
            </Typography>
            <LanguageSwitcher theme="inline" />
          </Box>
        </Container>
      </div>
    </footer>
  );
}

export default Footer;
